module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "orders-payments"
  }, [(_vm.order.purchaseOrderNumber != null && _vm.order.isPurchaseOrderBtnAvailable) ? _c('div', {
    staticClass: "bloc-btn-modify"
  }, [_c('button', {
    staticClass: "btn btn-modify",
    on: {
      "click": function($event) {
        _vm.updatePayments();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("orders.btnOrders.btnModify")))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "purchase-order"
  }, [(_vm.order.purchaseOrderNumber == null) ? _c('label', [_vm._v(_vm._s(_vm.$t("orders.labelPurchaseOrder")) + ":")]) : _c('label', [_vm._v(" " + _vm._s(_vm.$t("orders.purshaseOrderTitle")) + " : ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valuePurchaseOrderNumber),
      expression: "valuePurchaseOrderNumber"
    }],
    staticClass: "purchase-input",
    class: {
      empty: _vm.emptyPurchaseOrder
    },
    attrs: {
      "disabled": !!_vm.dataPurchaseOrderNumber
    },
    domProps: {
      "value": (_vm.valuePurchaseOrderNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.valuePurchaseOrderNumber = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.order.purchaseOrderNumber == null) ? _c('button', {
    staticClass: "btn purchase-btn",
    on: {
      "click": function($event) {
        _vm.purchaseOrder();
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t("orders.sendPurchaseOrder")) + "\n        ")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cbe0fc9e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/order-common/order-payments.vue
// module id = 3366
// module chunks = 0